import * as XLSX from 'xlsx';

export interface MarketData {
  DATE: number;
  REGION: string;
  ITEM: string;
  VARIETY: string;
  EXPORTER: string;
  BRAND: string;
  PRICE: number;
  SIZE: string;
  'WEIGHT/KG': string;
  KG: number;
  ' PRICE KG ': number; // Nota el espacio antes y después de PRICE KG
}

export class ExcelService {
  static async readFile(file: File): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const rawJsonData = XLSX.utils.sheet_to_json(worksheet) as Record<
            string,
            any
          >[];

          // Clean the keys by trimming all whitespace
          const cleanedJsonData = rawJsonData.map((row) => {
            const cleanedRow: Record<string, any> = {};
            Object.keys(row).forEach((key) => {
              cleanedRow[key.trim()] = row[key];
            });
            return cleanedRow;
          });

          resolve(cleanedJsonData);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  }
}

export function getWeekNumber(date: Date): number {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

// Función para convertir fecha a número de Excel
function convertToExcelDate(dateString: string): number {
  const date = new Date(dateString);
  return Math.floor(date.getTime() / 86400000 + 25569);
}
